/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ConfirmationRouteImport } from './routes/confirmation'
import { Route as Admin9k4m2p7x3bRouteImport } from './routes/admin-9k4m2p7x3b'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RsvpVariantRouteImport } from './routes/rsvp.variant'
import { Route as RsvpRosterRouteImport } from './routes/rsvp.roster'
import { Route as RsvpFighterRouteImport } from './routes/rsvp.fighter'
import { Route as RsvpChildRouteImport } from './routes/rsvp.child'

const ConfirmationRoute = ConfirmationRouteImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const Admin9k4m2p7x3bRoute = Admin9k4m2p7x3bRouteImport.update({
  id: '/admin-9k4m2p7x3b',
  path: '/admin-9k4m2p7x3b',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RsvpVariantRoute = RsvpVariantRouteImport.update({
  id: '/rsvp/variant',
  path: '/rsvp/variant',
  getParentRoute: () => rootRouteImport,
} as any)
const RsvpRosterRoute = RsvpRosterRouteImport.update({
  id: '/rsvp/roster',
  path: '/rsvp/roster',
  getParentRoute: () => rootRouteImport,
} as any)
const RsvpFighterRoute = RsvpFighterRouteImport.update({
  id: '/rsvp/fighter',
  path: '/rsvp/fighter',
  getParentRoute: () => rootRouteImport,
} as any)
const RsvpChildRoute = RsvpChildRouteImport.update({
  id: '/rsvp/child',
  path: '/rsvp/child',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-9k4m2p7x3b': typeof Admin9k4m2p7x3bRoute
  '/confirmation': typeof ConfirmationRoute
  '/rsvp/child': typeof RsvpChildRoute
  '/rsvp/fighter': typeof RsvpFighterRoute
  '/rsvp/roster': typeof RsvpRosterRoute
  '/rsvp/variant': typeof RsvpVariantRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-9k4m2p7x3b': typeof Admin9k4m2p7x3bRoute
  '/confirmation': typeof ConfirmationRoute
  '/rsvp/child': typeof RsvpChildRoute
  '/rsvp/fighter': typeof RsvpFighterRoute
  '/rsvp/roster': typeof RsvpRosterRoute
  '/rsvp/variant': typeof RsvpVariantRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin-9k4m2p7x3b': typeof Admin9k4m2p7x3bRoute
  '/confirmation': typeof ConfirmationRoute
  '/rsvp/child': typeof RsvpChildRoute
  '/rsvp/fighter': typeof RsvpFighterRoute
  '/rsvp/roster': typeof RsvpRosterRoute
  '/rsvp/variant': typeof RsvpVariantRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-9k4m2p7x3b'
    | '/confirmation'
    | '/rsvp/child'
    | '/rsvp/fighter'
    | '/rsvp/roster'
    | '/rsvp/variant'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-9k4m2p7x3b'
    | '/confirmation'
    | '/rsvp/child'
    | '/rsvp/fighter'
    | '/rsvp/roster'
    | '/rsvp/variant'
  id:
    | '__root__'
    | '/'
    | '/admin-9k4m2p7x3b'
    | '/confirmation'
    | '/rsvp/child'
    | '/rsvp/fighter'
    | '/rsvp/roster'
    | '/rsvp/variant'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Admin9k4m2p7x3bRoute: typeof Admin9k4m2p7x3bRoute
  ConfirmationRoute: typeof ConfirmationRoute
  RsvpChildRoute: typeof RsvpChildRoute
  RsvpFighterRoute: typeof RsvpFighterRoute
  RsvpRosterRoute: typeof RsvpRosterRoute
  RsvpVariantRoute: typeof RsvpVariantRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/confirmation': {
      id: '/confirmation'
      path: '/confirmation'
      fullPath: '/confirmation'
      preLoaderRoute: typeof ConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-9k4m2p7x3b': {
      id: '/admin-9k4m2p7x3b'
      path: '/admin-9k4m2p7x3b'
      fullPath: '/admin-9k4m2p7x3b'
      preLoaderRoute: typeof Admin9k4m2p7x3bRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rsvp/variant': {
      id: '/rsvp/variant'
      path: '/rsvp/variant'
      fullPath: '/rsvp/variant'
      preLoaderRoute: typeof RsvpVariantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rsvp/roster': {
      id: '/rsvp/roster'
      path: '/rsvp/roster'
      fullPath: '/rsvp/roster'
      preLoaderRoute: typeof RsvpRosterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rsvp/fighter': {
      id: '/rsvp/fighter'
      path: '/rsvp/fighter'
      fullPath: '/rsvp/fighter'
      preLoaderRoute: typeof RsvpFighterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rsvp/child': {
      id: '/rsvp/child'
      path: '/rsvp/child'
      fullPath: '/rsvp/child'
      preLoaderRoute: typeof RsvpChildRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Admin9k4m2p7x3bRoute: Admin9k4m2p7x3bRoute,
  ConfirmationRoute: ConfirmationRoute,
  RsvpChildRoute: RsvpChildRoute,
  RsvpFighterRoute: RsvpFighterRoute,
  RsvpRosterRoute: RsvpRosterRoute,
  RsvpVariantRoute: RsvpVariantRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
